import React, { useEffect, useState, useCallback } from "react";
import style from "../certificateCondition/certificateCondition.module.css";
import { useNavigate } from "react-router-dom";
import Table, { tableCustomStyles } from "../../../components/CommonComponents/Table/Table";
import PageHeader from "../../../components/pageHeader/pageHeader";
import axios from "axios";
import { ErrorToast } from "../../../components/toastMessage";
import { BASE_URL } from "../../../constants/Constants";
import { useDebounce } from "../../../hooks/common";
import Dropdown from "react-bootstrap/esm/Dropdown";
import Paginator, { PaginatorForRDT } from "../../../components/CommonComponents/Paginator/Paginator";
import { formatDate } from "../../../utils/date";
import Edit from "../../../assets/EditInWhite.svg";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditButton, { ViewButton } from "../../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../../utils/axios";

const CertificateConditions = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalList, setTotalList] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const search = useDebounce(searchQuery);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [lastDate, setLastDate] = useState<string | null>(null);
  const [certificateConditionList, setCertificateConditionList] = useState([]);
  const [isGridView, setIsGridView] = useState(false);

  const navigate = useNavigate();

  const getCertificateConditionList = useCallback(() => {
    _axios.post(`${BASE_URL}/api/certificate-condition/list`,
      {
        page: currentPage,
        limit: entriesPerPage,
        search: search,
        filters: selectedFilters,
        lastDate
      }
    )
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }

        setTotalList(response.data.data.total_rows);
        setCertificateConditionList(response?.data?.data.results);
        console.log('response', response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [currentPage, entriesPerPage, search, selectedFilters, lastDate]);

  useEffect(() => {
    getCertificateConditionList();
  }, [currentPage, entriesPerPage, search, selectedFilters, lastDate, getCertificateConditionList]);

  const handleEntriesChange = (e: { target: { value: any; }; }) => {
    setEntriesPerPage(Number(e.target.value));
  };

  const columns = [
    {
      name: 'Sr. No.',
      grow: 0.5,
      // selector: (row: any, rowIndex: number | undefined) => (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      sortable: false,
    },
    {
      name: 'Name Of Service',
      grow: 3,
      selector: (row: any) => row.name_of_service,
      cell: (row: any) => (<span className="text-center">{row.name_of_service || "-"}</span>),
      sortable: true,
    },
    {
      name: 'Last Publish Date',
      grow: 1,
      cell: (row: any) => formatDate(new Date(row.submitted_date)),
      selector: (row: any) => row.submitted_date,
      sortable: true,
      width: "220px",
      sortFunction: (a: any, b: any) => {
        const dateA = new Date(a.submitted_date);
        const dateB = new Date(b.submitted_date);
        if (dateA.getFullYear() !== dateB.getFullYear()) {
          return dateA.getFullYear() - dateB.getFullYear();
        }
        if (dateA.getMonth() !== dateB.getMonth()) {
          return dateA.getMonth() - dateB.getMonth();
        }
        return dateA.getDate() - dateB.getDate();
      },
    },
    {
      name: 'Status',
      cell: (row: any) => (
        <button className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}>
          {row.status === 1 ? "Active" : "Inactive"}
        </button>
      ),
      sortable: false,
    },
    {
      name: 'Created By',
      selector: (row: any) => row.created_by,
      cell: (row: any) => <span className="text-center">{row.created_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Created On',
      selector: (row: any) => formatDate(new Date(row.created_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified By',
      selector: (row: any) => row.modified_by,
      cell: (row: any) => <span className="text-center">{row.modified_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified On',
      selector: (row: any) => formatDate(new Date(row.modified_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Action',
      grow: 0.5,
      cell: (row: any) => (
        <div className="flex space-x-2">
          <EditButton
            onClick={() => { navigate("/new-certificate-condition", { state: { documentData: row } }) }}
          />
          <ViewButton
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const handleFilterChange = (filter: string, value?: string) => {
    console.log("Filter:", filter);
    console.log("Value:", value);

    let filterValue;

    if (filter === "Active") {
      filterValue = "1";
    } else if (filter === "Inactive") {
      filterValue = "0";
    } else {
      filterValue = filter;
    }

    if (filter !== 'lastDate') {
      const index = selectedFilters.indexOf(filterValue);
      if (index === -1) {
        setSelectedFilters([...selectedFilters, filterValue]);
      } else {
        const updatedFilters = [...selectedFilters];
        updatedFilters.splice(index, 1);
        setSelectedFilters(updatedFilters);
      }
    }
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      // Adjust for timezone issues, if any
      const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const dateString = adjustedDate.toISOString().split('T')[0];
      setLastDate(dateString); // Update selected date
      getCertificateConditionList(); // Call your function to handle the date filter change
    } else {
      setLastDate(null); // Handle clearing the date
    }
  };

  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className={style.DropDropMenu}>
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropTile}>Certificate Conditions filter</Dropdown.Header>
            <ul>
              <li>
                <div className={style.dropdownCheck}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes('1')}
                    onChange={() => handleFilterChange("Active")}
                  />{" "} <label >Active Status</label>
                </div>
              </li>
              <li>
                <div className={style.dropdownCheck}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes('0')}
                    onChange={() => handleFilterChange("Inactive")}
                  />{" "}Inactive Status
                </div>
              </li>
              <li>
                <span className="text-sm pl-2"> Last Publish Date</span>
                <DatePicker
                  selected={lastDate ? new Date(lastDate) : null} // Convert string to Date object
                  onChange={handleDateChange}
                  dateFormat="dd/MM/yyyy"
                  className="border border-black"
                  isClearable // Enables built-in clear button
                />
              </li>
            </ul>
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );

  return (
    <div className="p-8 overflow-auto">
      <PageHeader
        title="Certificate Condition List"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        showSearchButton={true}
        showAdditionalButton={true}
        buttonTitle="Create Condition"
        onClick={() => { navigate("/new-certificate-condition") }}
        isGridView={isGridView}
        onGridIconClick={() => setIsGridView(!isGridView)}
        showFilterButton={true}
        dropdownContent={dropdownContent}
      />
      {isGridView ? (
        <>
          <BoxComponent>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {certificateConditionList?.filter(
                (row: any) => row?.name_of_service.toLowerCase().includes(searchQuery.toLowerCase()))
                .map((row: any) => {
                  return (
                    <div className="p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300">
                      <div className="flex justify-between items-center space-x-4 mb-4">
                        <button className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}>
                          {row.status === 1 ? "Active" : "Inactive"}
                        </button>
                        <div className="flex space-x-2">
                          <EditButton
                            onClick={() => navigate("/new-certificate-condition", { state: { documentData: row } })}
                          />
                          <ViewButton
                            disabled={true}
                            onClick={function (): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-2 flex text-[12px]">
                        <p className="font-bold text-base w-1/2">Name of Service</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{row?.name_of_service}</p>
                      </div>
                      <div className="mb-2 flex text-[12px]">
                        <p className="font-bold text-base w-1/2">Last Published Date</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{formatDate(new Date(row?.submitted_date)) ?? '09/06/2023'}</p>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <Paginator
              limit={entriesPerPage}
              page={currentPage}
              setPage={(p) => setCurrentPage(p)}
              count={totalList || 0}
            />
          </BoxComponent>
        </>
      ) : (
        <BoxComponent>
          <Table columns={columns}
            data={certificateConditionList}
            paginationTotalRows={totalList || 0}
            onChangePage={(p) => setCurrentPage(p)}
            customStyles={tableCustomStyles}
            paginationComponent={PaginatorForRDT}
          />
        </BoxComponent>
      )}
    </div>
  );
};

export default CertificateConditions
